import { render, staticRenderFns } from "./fixedCollectionInterfaceElement.vue?vue&type=template&id=de676e2a&scoped=true&"
import script from "./fixedCollectionInterfaceElement.vue?vue&type=script&lang=js&"
export * from "./fixedCollectionInterfaceElement.vue?vue&type=script&lang=js&"
import style0 from "./fixedCollectionInterfaceElement.vue?vue&type=style&index=0&id=de676e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de676e2a",
  null
  
)

export default component.exports